import React from "react";
import Link from "gatsby-link";
import Carousel from "nuka-carousel";
import ClassNames from "classnames";
import Item from "./testimonial-item";

let tweetRe = /(^|[^'"])(https?:\/\/twitter\.com\/(?:#!\/)?(\w+)\/status(?:es)?\/(\d+))/;

class Testimonials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      n: 0
    };
    this.carouselUpdated = this.carouselUpdated.bind(this);
  }

  carouselUpdated(index) {
    this.setState({
      n: index
    });
  }

  render() {
    const testimonials = this.props.data;
    return (
      <div className="Testimonials mobile">
        <div className="internal">
          <h2>What people are saying</h2>
          <Carousel
            className="items"
            autoGenerateStyleTag={true}
            ref={el => {
              this.swipe = el;
            }}
            className="items"
            cellAlign="center"
            withoutControls={true}
            afterSlide={this.carouselUpdated}
            heightMode="max"
            slidesToShow={1}
            slideWidth={0.86}
          >
            {testimonials.map((item, i) => {
              return <Item data={item} key={i} />;
            })}
          </Carousel>
        </div>
        <div className="dots">
          {testimonials.map((item, i) => {
            return (
              <div
                className={ClassNames({
                  dot: true,
                  "is-active": this.state.n === i
                })}
                key={i}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/home/testimonials-mobile.js